import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

import { Button } from '../../../components/ui';
import { useT } from '../../../i18n';
import { useToast } from '../../../lib/toast';

/** Thời gian giữ dấu "Đã sao chép" trên nút. */
const GIU_DA_CHEP_MS = 2_000;

/**
 * Sao chép vào clipboard và nhớ ô vừa chép trong một nhịp. Clipboard API chỉ có trên https hoặc localhost; thiếu
 * thì nói để người dùng tự chọn chữ.
 */
export function useSaoChep() {
  const { t } = useT();
  const toast = useToast();
  const [daChep, setDaChep] = useState<string | null>(null);

  const chep = (khoa: string, giaTri: string) => {
    const ghi = navigator.clipboard?.writeText(giaTri) ?? Promise.reject(new Error('clipboard'));
    ghi.then(
      () => {
        setDaChep(khoa);
        window.setTimeout(() => setDaChep((cu) => (cu === khoa ? null : cu)), GIU_DA_CHEP_MS);
      },
      () => toast.warning(t('tenant.dnsKhongSaoChepDuoc')),
    );
  };
  return { daChep, chep };
}

/** Một ô của bản ghi DNS: nhãn, giá trị chữ đơn cách, nút sao chép. */
export function OBanGhi({
  nhan,
  giaTri,
  daChep,
  onChep,
}: {
  nhan: string;
  giaTri: string;
  daChep: boolean;
  onChep: () => void;
}) {
  const { t } = useT();
  return (
    <div className="flex flex-col gap-1 border-b border-default py-2.5 last:border-0 sm:flex-row sm:items-center sm:gap-3">
      <span className="w-24 shrink-0 text-xs text-content-muted">{nhan}</span>
      <code className="min-w-0 flex-1 break-all rounded bg-subtle px-2 py-1 font-mono text-xs text-content-primary">
        {giaTri}
      </code>
      <Button
        variant="ghost"
        size="sm"
        className="self-start sm:self-auto"
        aria-label={t('tenant.dnsSaoChepNhan', { truong: nhan })}
        onClick={onChep}
      >
        {daChep ? <Check size={14} className="text-success-600" /> : <Copy size={14} />}
        <span aria-live="polite">{daChep ? t('tenant.dnsDaSaoChep') : t('tenant.dnsSaoChep')}</span>
      </Button>
    </div>
  );
}
